<template>
  <div>
    <div v-if="!isCheckCapacity" class="row-tb-head" style="margin: 10px 0">
      <span>模具信息</span>
      <el-button type="primary" v-show="mouldBoms && mouldBoms.length > 0 && false" style="margin-left: 18px" @click="openPrint">打印</el-button>
      <template v-if="mouldBoms && mouldBoms.length > 0"
        ><span style="margin-left: 18px">预计完工日期</span>
        <span style="margin: 0 10px"> <el-date-picker v-model="batchShowEndTime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime"> </el-date-picker> </span
      ></template>
    </div>
    <div v-if="!isCheckCapacity" style="font-size: 14px; line-height: 30px; color: #606266; margin-bottom: 10px" class="flex2">
      <div>多选操作：</div>
      <div class="flex2">
        <div></div>
        <div style="margin: 0 10px">
          <el-date-picker :disabled="!selList.length" v-model="batchDocDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="批量修改选中单据日期" @change="onDocDate">
          </el-date-picker>
        </div>
      </div>
      <div class="flex2">
        <div></div>
        <div style="margin: 0 10px">
          <el-date-picker
            :disabled="!selList.length"
            v-model="batchEndTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="批量修改选中预计完工日期"
            @change="onDocEndTime"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="flex2">
        <div>生产部门</div>
        <div style="margin: 0 10px">
          <dp-select ref="dpSelect" style="width: 180px" @input="changeDp" v-model="DpId" :disabled="!selList.length" />
        </div>
      </div>
    </div>
    <el-table
      :data="mouldBoms"
      class="table_bottom table-line tb-c-head"
      border
      ref="list1"
      max-height="353"
      @row-click="rowClick"
      :row-class-name="tableRowClassName"
      :highlight-current-row="true"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" fixed="left"></el-table-column>
      <el-table-column type="index" label="序号" fixed="left" />
      <!-- <el-table-column prop="Pname" label="产品名称" min-width="120" fixed="left"></el-table-column> -->
      <el-table-column prop="MouldName" label="模具名称" min-width="120" fixed="left"></el-table-column>
      <el-table-column prop="OrderProductNo" label="布产单号" min-width="120" v-if="!isCheckCapacity"> </el-table-column>
      <el-table-column prop="WorkDocNo" label="工单号" min-width="120" v-if="!isCheckCapacity"></el-table-column>
      <el-table-column prop="MouldNo" label="模号" min-width="120"></el-table-column>
      <el-table-column prop="BatchNumber" label="批 号" min-width="120"></el-table-column>
      <el-table-column prop="BarCode" label="存货条码" min-width="120" v-if="false"></el-table-column>
      <el-table-column prop="ColorName" label="颜色" min-width="120" v-if="!isCheckCapacity"></el-table-column>
      <el-table-column prop="PerGrossWeight" label="每模毛重" min-width="120" v-if="!isCheckCapacity"></el-table-column>
      <el-table-column prop="PerNetWeight" label="每模净重" min-width="120" v-if="!isCheckCapacity"></el-table-column>
      <el-table-column prop="Afew" label="1出几腔" min-width="120"></el-table-column>
      <el-table-column prop="Wages" label="加工单价" min-width="120">
        <template slot-scope="{ row }">
          <el-input v-model="row.Wages" type="text" @change="editT(row)" v-if="Status === 0"></el-input>
          <span v-else>{{ row.Wages }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity" label="需求模数" min-width="120">
        <template slot-scope="{ row }">
          <el-input v-if="Status === 0" v-model="row.qua" @change="changePQuantity($event, row)" />
          <span v-else>{{ $commonJs.toThousands(row.qua) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="'需求重量' + '(' + NeedUnit + ')'" min-width="120">
        <template slot-scope="{ row }">
          <span>{{ ((row.qua * row.PerGrossWeight) / NeedRate).toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Inventory" label="库存数量" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Inventory) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity" label="生产数量" min-width="120">
        <template slot-scope="{ row }">
          <span>{{ row.qua - (row.Inventory ?? 0) < 0 ? 0 : row.qua - (row.Inventory ?? 0) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="InQuantity" label="累计入库数" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.InQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="未入库数" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <span>{{ row.Quantity && row.InQuantity ? (row.Quantity - row.InQuantity > 0 ? row.Quantity - row.InQuantity : 0) : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="PickingWarehouseId" label="预入仓" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <el-select v-model="row.PickingWarehouseId">
            <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="UnqualifiedInWarehouseId" label="不合格预入仓" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <el-select v-model="row.UnqualifiedInWarehouseId">
            <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column key="column1" v-if="!QuickProcess" prop="SchedulingType" label="排产类型" min-width="120">
        <template slot-scope="{ row }">
          <el-select v-if="Status === 0" v-model="row.SchedulingType" @change="changeSchedulingType($event, row)" v-show="!QuickProcess">
            <el-option key="SchedulingType1" label="部门" :value="0"></el-option>
            <el-option key="SchedulingType2" v-show="row.ProductionType === 0" label="设备" :value="1"></el-option>
          </el-select>
          <span v-show="!QuickProcess" v-else>{{ row.SchedulingType === 0 ? '部门' : '设备' }}</span>
        </template>
      </el-table-column>
      <el-table-column key="column2" v-if="!QuickProcess" label="生产部门/设备" min-width="120">
        <template slot-scope="{ row }">
          <dp-select v-if="row.SchedulingType === 0" style="width: 180px" :disabled="Status === 1" @input="editT(row)" v-model="row.DpId" v-show="row.showDp" />
          <el-select v-else style="width: 180px" @input="editT(row)" :disabled="Status === 1" v-model="row.MaintenanceId" v-show="row.showMt" @change="changeEquipment(row, $event)">
            <el-option v-for="item in equipmentList" :key="item.EquipmentId" :label="item.EquipmentName" :value="item.EquipmentId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="生产部门" min-width="120" key="column2" v-else>
        <template slot-scope="{ row }">
          <dp-select v-show="row.ProductionType == 0" style="width: 180px" @input="editT(row)" :disabled="Status === 1" v-model="row.DpId" />
        </template>
      </el-table-column>
      <!-- <el-table-column label="生产部门" min-width="120" key="column2">
        <template slot-scope="{ row }">
          <dp-select v-show="row.ProductionType == 0" style="width: 180px" @input="editT(row)" :disabled="Status === 1" v-model="row.DpId" />
        </template>
      </el-table-column> -->
      <el-table-column prop="ProductionType" label="生产类型" min-width="120">
        <template slot-scope="{ row }">
          <el-select v-model="row.ProductionType" @change="editT(row)" v-if="Status === 0">
            <el-option v-if="row.currentProductNature === 2 || row.currentProductNature === 0" key="ProductionType1" label="自产" :value="0"></el-option>
            <el-option v-if="row.currentProductNature === 2 || row.currentProductNature === 1" key="ProductionType2" label="委外" :value="1"></el-option>
          </el-select>
          <span v-else>{{ row.ProductionType === 0 ? '自产' : '委外' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ProductionDpId" label="加工商" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <el-select v-model="row.ProductionDpId" @change="editT(row)" v-if="row.ProductionType === 1" :disabled="row.ProductionType === 1 && Status !== 0" filterable>
            <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :label="item.FullName" :value="item.TradeUnitId"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="DocDate" label="单据日期" min-width="120" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <el-date-picker v-if="Status === 0" v-model="row.DocDate" @change="editT(row)" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" placeholder="选择日期"> </el-date-picker>
          <span v-else>{{ row.DocDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="EndTime" label="预计完工日期" min-width="180">
        <template slot-scope="{ row }">
          <el-date-picker v-if="Status === 0" v-model="row.EndTime" @change="changeEndTime(row)" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期">
          </el-date-picker>
          <span v-else>{{ row.EndTime }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Remark" label="工单备注" min-width="180" v-if="!isCheckCapacity">
        <template slot-scope="{ row }">
          <el-input v-if="Status === 0" clearable v-model="row.Remark" @change="editT(row)" placeholder="请输入工单备注"></el-input>
          <span v-else>{{ row.Remark }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="MouldBomNo" label="BOM版本号" min-width="120"></el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="80">
        <template slot-scope="{ row, $index }">
          <el-button type="text" @click="delPro(row, $index)">删除</el-button>
        </template>
      </el-table-column>
      <slot name="column"></slot>
    </el-table>
    <el-tabs v-model="activeName" type="card" v-show="isShowTabs">
      <el-tab-pane label="胶件" name="1">
        <el-table :data="itemrubbersView" class="table_bottom table-line tb-c-head" border ref="list1">
          <el-table-column prop="Pno" label="胶件编号" min-width="120"></el-table-column>
          <el-table-column prop="Pname" label="胶件名称" min-width="120"></el-table-column>
          <el-table-column prop="BatchNumber" label="批号" min-width="120"></el-table-column>
          <el-table-column prop="BarCode" label="存货条码" min-width="120"></el-table-column>
          <el-table-column prop="PropertyName" label="属性" min-width="120"></el-table-column>
          <el-table-column prop="ColorName" label="颜色" min-width="120"></el-table-column>
          <el-table-column prop="NetWeight" label="净重" min-width="120"></el-table-column>
          <el-table-column prop="MouldNo" label="模具编号" min-width="120"></el-table-column>
          <el-table-column prop="Quantity" label="需求数量" min-width="120">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(row.qua) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ImgUrl" label="产品图片" min-width="120">
            <template slot-scope="{ row }">
              <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }} </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="Remarks" label="备注" min-width="120"></el-table-column>
          <el-table-column prop="StockQuantity" label="库存数量" min-width="120">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(row.StockQuantity) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ExistQuantity" label="可用量" min-width="120">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(row.ExistQuantity) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Quantity" label="生产数量" min-width="120">
            <template slot-scope="{ row }">
              <span>{{ row.qua - (row.StockQuantity ?? 0) < 0 ? 0 : row.qua - (row.StockQuantity ?? 0) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="InQuantity" label="累计入库数" min-width="120">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(row.InQuantity) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="未入库数" min-width="120">
            <template slot-scope="{ row }">
              <span>{{ row.qua && row.InQuantity ? row.qua - row.InQuantity : '' }}</span>
            </template>
          </el-table-column>
          <slot name="column"></slot>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="模具材料" name="2">
        <div class="flex" v-if="Status === 0">
          <div>{{ isShowTabs && itemDetailModels.length > 0 ? itemDetailModels[0].Pname : '' }}</div>
          <el-button type="primary" v-show="isShowTabs" @click="add">添加</el-button>
        </div>
        <div v-for="(item, index) in itemDetailModels" :key="index">
          <el-table :data="item.DetailModels" class="table_bottom table-line tb-c-head" border ref="list1">
            <el-table-column prop="Pno" label="存货编码" min-width="120"></el-table-column>
            <el-table-column prop="Pname" label="存货名称" min-width="120">
              <template slot-scope="{ row, $index }">
                <account-select
                  v-if="Status === 0"
                  v-model="row.Pname"
                  :source="DAccount"
                  @select="onSelect($event, row, $index)"
                  :pageSize="pageParams.pageSize"
                  :pageIndex="pageParams.pageIndex"
                  :listTotal="listTotal"
                  @inputText="inputText"
                  @click.native="resetFun"
                  @currentPage="currentPage"
                  :pageType="true"
                />
                <span v-else>{{ row.Pname }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ProductSpec" label="规格" min-width="120"></el-table-column>
            <el-table-column prop="BatchNumber" label="批号" min-width="120"></el-table-column>
            <el-table-column prop="PropertyName" label="属性" min-width="120"></el-table-column>
            <el-table-column prop="ColorName" label="颜色" min-width="120"></el-table-column>
            <el-table-column prop="PdUnitName" label="单位" min-width="120"></el-table-column>
            <el-table-column prop="Quantity" label="需求数量" min-width="126" align="center">
              <template slot-scope="{ row }">
                <el-input v-if="Status === 0" clearable v-model="row.qua" @change="changeQua($event, row)" placeholder="请输入数量" type="number" />
                <span v-else>{{ $commonJs.toThousands(row.qua) }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="UnitName2" label="单位2" min-width="120"></el-table-column>
            <el-table-column prop="Quantity2" label="需求数量2" min-width="126" align="center">
            </el-table-column> -->
            <el-table-column prop="ImgUrl" label="产品图片" min-width="120">
              <template slot-scope="{ row }">
                <el-button type="text" @click="viewImg(row)">{{ row.ProductId ? '查看' : '' }} </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="ProcessStageName" label="加工阶段" min-width="120"> </el-table-column>
            <el-table-column prop="ProduceTypeName" label="存货类型" min-width="120"> </el-table-column>
            <el-table-column prop="StockQuantity" label="库存数量" min-width="120">
              <template slot-scope="{ row }">
                <span>{{ $commonJs.toThousands(row.StockQuantity) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ExistQuantity" label="可用量" min-width="120">
              <template slot-scope="{ row }">
                <span>{{ $commonJs.toThousands(row.ExistQuantity) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="PickingQuantity" label="领用数量" min-width="120">
              <template slot-scope="{ row }">
                <span>{{ $commonJs.toThousands(row.PickingQuantity) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ConsumeQuantity" label="耗用数量" min-width="120">
              <template slot-scope="{ row }">
                <span>{{ $commonJs.toThousands(row.ConsumeQuantity) }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="工艺" name="3">
        <div v-for="(item, index) in itemProcessModels" :key="index">
          <div class="flex1">
            <div class="flex2">
              <div class="mr8">{{ item.ProgrammeName }}</div>
              <el-button type="primary" @click="changeProgramme(item, index)">选择方案</el-button>
            </div>
          </div>

          <el-table :data="item.Processes" class="table_bottom table-line tb-c-head" border ref="list3">
            <el-table-column prop="ProcessId" label="工序名称" min-width="120">
              <template slot-scope="{ row }">
                <el-select v-model="row.ProcessId">
                  <el-option v-for="(item, index) in teProcessList" :key="index" :value="item.ProcessId" :label="item.ProcessName"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="ProductionType" label="自制工序或者委外工序" min-width="120">
              <template slot-scope="{ row }">
                <el-select v-model="row.ProcessType" @change="changeProcessType(row)" :disabled="disabled">
                  <el-option key="a1" label="自制工序" :value="0"></el-option>
                  <el-option key="a2" label="委外工序" :value="1"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="TradeUnitId" label="委外供应商" min-width="120">
              <template slot-scope="{ row }">
                <div class="flex" v-show="row.ProcessType === 1">
                  <span v-if="disabled">{{ row.TradeUnitName }}</span>
                  <el-input v-else type="text" v-model="row.TradeUnitName" readonly />
                  <el-button v-if="!disabled" type="primary" @click="selectCome(row)">选择</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <come-list-dialog @select="comeSelect" selectable :multiple="false" ref="comeListDialog" in-dialog />
    <detail-dialog ref="detailDialog" @saved="detail_saved"></detail-dialog>
    <img-dialog ref="imgDialog" :imgs="imgs" />
    <list-dialog ref="listDialog" selectable :multiple="false" @select="listDialogSelect"></list-dialog>
    <print-dialog ref="printDialog" @printed="printed"></print-dialog>
  </div>
</template>
<script>
import accountSelect from '../select'
import { clothDialogApi } from '@/data/production/test'
import comeListDialog from '@/components/basedata/business/come/listDialog'
import detailDialog from './detailDialog'
import printDialog from './printDialog'

import imgDialog from './imgDialog'
import dpSelect from './dpSelect'
import vSelect from './vSelect'
import listDialog from '@/components/production/craftsmanship/solutions/mold/listDialog'

export default {
  components: {
    accountSelect,
    comeListDialog,
    detailDialog,
    imgDialog,
    dpSelect,
    vSelect,
    listDialog,
    printDialog
  },
  data() {
    return {
      api: clothDialogApi,
      activeName: '1',
      tableData: [],
      innerTableData: [],
      mouldTableData: [],
      sumTableData: [],
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      mouldApi: require('@/api/ba/mould').default,
      mouldData: {},
      teMouldBomApi: require('@/api/production/teMouldBom').default,
      equipmentApi: require('@/api/ba/equipment').default,
      workdocApi: require('@/api/production/workDoc').default,
      tradeUnitList: [],
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      currentRow: null,
      programmeCurrentRow: null,
      programmeCurrentIndex: null,

      rubbers: [],
      mouldBoms: [],
      DetailModels: [],
      ProcessModels: [],
      imgs: [],
      deltetRubbers: [],

      copyMouldBoms: [],
      copyDetailModels: [],
      copyProcessModels: [],
      deleteMouldBom: [],
      deleteProcessModels: [],
      deleteDetailModels: [],
      rubbersView: [],
      equipmentList: [],

      teProcessApi: require('@/api/production/teProcess').default,
      pdApi: require('@/api/ba/product').default,
      teProcessList: [],
      disabled: false,
      itemProcessModels: [],
      itemDetailModels: [],
      itemrubbersView: [],
      isShowTabs: false,
      currentIndex: -1,
      deleteProcess: [],
      NeedUnit: '斤',
      NeedRate: 500,
      warehouseList: [],
      selList: '', //选中行的列表
      batchDocDate: null, //批量单据日期
      batchEndTime: null, //预计完工日期
      batchShowEndTime: null, //预计完工日期
      DpId: null
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: () => true
    },
    Status: {
      type: Number,
      default: 0
    },
    QuickProcess: {
      type: Boolean,
      default: false
    },
    InjectionMouldBoms: {
      type: Array,
      default: () => []
    },
    InjectionRubbers: {
      type: Array,
      default: () => []
    },
    scQuantity: {
      type: Number,
      default: 1
    },
    editRubbers: {
      type: Array,
      default: () => []
    },
    editInjection: {
      type: Array,
      default: () => []
    },
    OrderProductNo: {
      type: String,
      default: ''
    },
    productLists: {
      type: Array,
      default: () => []
    },
    editType: {
      type: Number,
      default: 0
    },
    tradeUnitListProp: {
      type: Array,
      default: () => []
    },
    equipmentListProp: {
      type: Array,
      default: () => []
    },
    warehouseProp: {
      type: Array,
      default: () => []
    },
    isCheckCapacity: {
      type: Boolean,
      default: () => false
    },
    initProductProp: {
      type: Object,
      default: () => {}
    },
    teProcessProp: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    teProcessProp: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(val, 'teProcessProp')
        this.teProcessList = val
      }
    },
    initProductProp: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(val, 'initProductData')
        this.DAccount = val.Data
        this.initDAccount = val.Data
        this.initTotal = val.Count
        this.listTotal = val.Count
      }
    },
    tradeUnitListProp: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(val, 'tradeUnitListProp')
        this.tradeUnitList = val
      }
    },
    equipmentListProp: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(val, 'equipmentListProp')
        this.equipmentList = val
      }
    },
    scQuantity(val) {
      console.log('注塑 val===========', val)
      this.rubbers.forEach(item => {
        if (item.qua) {
          if (this.editType === 1 && item.T !== 0) {
            item.T = 1
          }
          item.qua = Math.ceil(item.Quantity * val)
        }
      })

      let rubbers = this.sumRubbers(this.rubbers)

      this.rubbersView = this.sumRubbers(this.rubbers)

      this.$emit('setListEnd', rubbers)

      // this.mouldBoms.forEach((item) => {
      //   if (item.qua) {
      //     item.qua = Math.ceil(item.Quantity * val);
      //   }
      // });

      // this.DetailModels.forEach((item) => {
      //   item.DetailModels.forEach((v) => {
      //     v.qua = Math.ceil(v.Quantity * val);
      //   });
      // });
    },
    InjectionMouldBoms: {
      deep: true,
      immediate: true,
      handler(val) {
        val?.forEach(item => {
          item.WorkRubberId = item.WorkRubberId ? item.WorkRubberId : 0
          item.InQuantity = item.InQuantity ? item.InQuantity : 0
          item.Pno = item.ProductNo
          item.Pname = item.ProductName
          console.log(item, val, 'InjectionMouldBoms aa')
          this.$set(item, 'DpId', item.DpId)
          this.$set(item, 'qua', Math.ceil(item.Quantity * this.scQuantity))
          this.$set(item, 'showDp', true)
          this.$set(item, 'showMt', false)
          this.$set(item, 'Wages', item.Wages)
          this.$set(item, 'UnqualifiedInWarehouseId', item.UnqualifiedInWarehouseId)
          // if (item.DpId) {

          // }
          if (item.MaintenanceId) {
            this.$set(item, 'showDp', false)
            this.$set(item, 'showMt', item.ProductNature == 0)
          }
        })
        this.rubbers = val
        this.rubbersView = this.sumRubbers(this.rubbers)
      }
    },

    editRubbers(val) {
      console.log('注塑工单胶件触发更新', val)

      val.forEach(item => {
        this.$set(item, 'qua', item.Quantity * this.scQuantity)
        item.Pno = item.ProductNo
        item.Pname = item.ProductName
        item.PropertyId = item.Property ? item.Property : 0
        item.ChildBomNo = item.ChildGroupNo !== '' && item.ChildGroupNo != null ? item.ChildGroupNo : item.ChildBomNo
      })

      this.changeT(val)
      this.rubbers = val

      if (val.length > 0) {
        this.workdocApi.getClothStage({ Stage: 0, OrderProductId: val[0].OrderProductId }).then(res => {
          if (res.Code === 0) {
            this.batchShowEndTime = res.Data.EndTime
          }
        })
      }
      this.rubbersView = this.sumRubbers(val)

      console.log('edit this.rubbers', this.rubbers)
    },
    editInjection(val) {
      let _ProductModels = []
      let _ProcessModels = []
      let _MaterialModels = []

      console.log('注塑工单触发更新', val)

      val.forEach(item => {
        let { MaterialModels, ProcessModels, ProductModels, ...rest } = item

        // console.log("=========MaterialModels========", MaterialModels);

        MaterialModels.forEach(item => {
          item.PdUnitName = item.UnitName
          item.PdUnitId = item.QuantityUnit
          item.Pname = item.ProductName
          item.Pno = item.ProductNo
          this.$set(item, 'qua', item.Quantity * this.scQuantity)
        })

        ProductModels.forEach(item => {
          item.OrderProductNo = this.OrderProductNo
          item.MouldQua = item.Quantity

          item.currentProductNature = item.MouldNature

          for (let i in rest) {
            if (!item.hasOwnProperty(i)) {
              this.$set(item, i, rest[i])
            }
          }

          if (MaterialModels.length !== 0) {
            let o1 = {
              MouldName: item.MouldName,
              mouldId: item.MouldId,
              MouldBomNo: item.MouldBomNo,
              id: item.MouldId + '_' + item.ColorId,
              fqua: item.Quantity,
              DetailModels: MaterialModels ?? []
            }

            _MaterialModels.push(o1)
          }

          let o = {
            MouldName: item.MouldName,
            MouldNo: item.MouldNo,
            mouldId: item.MouldId,
            MouldBomNo: item.MouldBomNo,
            pid: item.MouldId + '_' + item.ColorId,
            ProgrammeName: ProcessModels[0]?.ProgrammeName ?? '',
            ProgrammeId: ProcessModels[0]?.ProgrammeId ?? 0,
            Processes: ProcessModels
          }

          _ProcessModels.push(o)
        })

        _ProductModels.push(...ProductModels)
      })

      _ProductModels.forEach(item => {
        console.log(item, item.DpId, 'dpid')
        this.$set(item, 'qua', item.Quantity)
        //if (item.DpId) {
        this.$set(item, 'showDp', true)
        this.$set(item, 'showMt', false)
        //}
        if (item.MaintenanceId) {
          this.$set(item, 'showDp', false)
          this.$set(item, 'showMt', item.ProductType == 0)
        }
      })

      _MaterialModels.forEach(item => {
        item.DetailModels.forEach(v => {
          v.rateQua = v.Quantity / item.fqua
        })
      })

      this.changeT(_ProductModels)
      this.changeT(_ProcessModels, 2)
      this.changeT(_MaterialModels, 1)

      this.mouldBoms = _ProductModels
      this.ProcessModels = _ProcessModels
      this.DetailModels = _MaterialModels

      this.copyMouldBoms = JSON.parse(JSON.stringify(this.mouldBoms))
      this.copyProcessModels = JSON.parse(JSON.stringify(this.ProcessModels))
      this.copyDetailModels = JSON.parse(JSON.stringify(this.DetailModels))

      console.log('===============this.DetailModels============', this.DetailModels)
    },
    warehouseProp: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(val, 'warehouseProp')
        this.warehouseList = val
      }
    }
  },
  created() {
    this.initProp()
    this.NeedUnit = localStorage.getItem('NeedUnit')
    this.NeedRate = localStorage.getItem('NeedRate')
    console.log('created')
    // this.tradeUnitApi.list({ TradeUnitTypes: [1, 3], Status: 1 }).then((res) => {
    //   if (res.Code === 0) {
    //     this.tradeUnitList = res.Data;
    //   }
    // });
  },
  mounted() {
    if (this.isEdit) {
      this.editInit()
    }
  },
  methods: {
    changeEndTime() {},
    changeDp(val) {
      this.mouldBoms = this.mouldBoms.map(obj1 => {
        let duplicateObj = this.selList.find(obj2 => obj2.MakeEmpId === obj1.MakeEmpId && obj2.MouldId === obj1.MouldId)
        if (duplicateObj) {
          obj1.DpId = this.DpId
        }
        return obj1
      })
      this.DpId = null
      this.$refs.dpSelect.value = null
      this.$refs.dpSelect.value1 = null
      this.$refs.dpSelect.init()
    },
    changeEquipment(row, val) {
      console.log(val, row, 'changeEquipment')
      this.getCapacity(val, row)
    },
    getCapacity(val, row) {
      this.equipmentApi.checkCapacity({ EquipmentId: val, MouldId: row.MouldId }).then(res => {
        if (res.Code === 0) {
          var obj = res.Data
          console.log(obj, row, 'obj')
          var hours = 0
          if (row.qua) {
            if (!obj.info.Cycle) {
              this.$message.warning('该设备未设置成品周期')
              return false
            }

            hours = Math.ceil(row.qua / obj.info.CycleOutPut)
            console.log(hours, obj.info.CycleOutPut, 'hours3')
          }
          console.log(hours, 'hours')
          if (obj.workdoc) {
            if (obj.workdoc.EndTime) {
              var endtime = new Date(obj.workdoc.EndTime)
              var newEndTime = new Date(endtime.getTime() + hours * 60 * 60 * 1000)
              var et = new Date(row.EndTime)
              if (newEndTime.getTime() > et.getTime()) {
                this.$confirm('完工时间比预设完工时间久, 是否替换预设完工时间?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                })
                  .then(() => {
                    row.EndTime = this.$commonJs.toDatetimeString(newEndTime)
                  })
                  .catch(() => {})
              }
            }
          } else {
            var endtime = new Date()
            var newEndTime = new Date(endtime.getTime() + hours * 60 * 60 * 1000)
            var et = new Date(row.EndTime)
            if (newEndTime.getTime() > et.getTime()) {
              this.$confirm('完工时间比预设完工时间久, 是否替换预设完工时间?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  row.EndTime = this.$commonJs.toDatetimeString(newEndTime)
                })
                .catch(() => {})
            }
          }
        }
      })
    },
    editInit() {
      let val = this.editInjection
      console.log(val, 'aa')
      let _ProductModels = []
      let _ProcessModels = []
      let _MaterialModels = []
      var BatchNumber_ = ''
      val.forEach(item => {
        let { MaterialModels, ProcessModels, ProductModels, BatchNumber, ...rest } = item
        console.log(item, 'editInit inject') // <!-- h -->
        BatchNumber_ = BatchNumber
        MaterialModels.forEach(item => {
          item.PdUnitName = item.UnitName
          item.PdUnitId = item.QuantityUnit
          item.Pname = item.ProductName
          item.Pno = item.ProductNo
          item.BatchNumber = BatchNumber
          this.$set(item, 'qua', item.Quantity * this.scQuantity)
        })

        ProductModels.forEach(item => {
          item.OrderProductNo = this.OrderProductNo
          item.MouldQua = item.Quantity
          item.BatchNumber = BatchNumber
          item.currentProductNature = item.MouldNature

          for (let i in rest) {
            if (!item.hasOwnProperty(i)) {
              this.$set(item, i, rest[i])
            }
          }

          if (MaterialModels.length !== 0) {
            let o1 = {
              MouldName: item.MouldName,
              mouldId: item.MouldId,
              MouldBomNo: item.MouldBomNo,
              id: item.MouldId + '_' + item.ColorId,
              fqua: item.Quantity,
              DetailModels: MaterialModels ?? [],
              BatchNumber: BatchNumber
            }

            _MaterialModels.push(o1)
          }

          let o = {
            MouldName: item.MouldName,
            MouldNo: item.MouldNo,
            mouldId: item.MouldId,
            MouldBomNo: item.MouldBomNo,
            pid: item.MouldId + '_' + item.ColorId,
            ProgrammeName: ProcessModels[0]?.ProgrammeName ?? '',
            ProgrammeId: ProcessModels[0]?.ProgrammeId ?? 0,
            Processes: ProcessModels,
            BatchNumber
          }

          _ProcessModels.push(o)
        })

        _ProductModels.push(...ProductModels)
      })

      _ProductModels.forEach(item => {
        this.$set(item, 'qua', item.Quantity)
        //if (item.DpId) {
        this.$set(item, 'showDp', true)
        this.$set(item, 'showMt', false)
        //}
        if (item.MaintenanceId) {
          this.$set(item, 'showDp', false)
          this.$set(item, 'showMt', item.ProductType == 0)
        }
      })

      _MaterialModels.forEach(item => {
        item.DetailModels.forEach(v => {
          v.rateQua = v.Quantity / item.fqua
        })
      })

      this.changeT(_ProductModels)
      this.changeT(_ProcessModels, 2)
      this.changeT(_MaterialModels, 1)

      this.mouldBoms = _ProductModels //ini <!-- h -->
      this.ProcessModels = _ProcessModels
      this.DetailModels = _MaterialModels

      this.copyMouldBoms = JSON.parse(JSON.stringify(this.mouldBoms))
      this.copyProcessModels = JSON.parse(JSON.stringify(this.ProcessModels))
      this.copyDetailModels = JSON.parse(JSON.stringify(this.DetailModels))

      var rubbers = this.editRubbers
      rubbers.forEach(item => {
        item.PdUnitName = item.UnitName
        item.PdUnitId = item.QuantityUnit
        item.Pname = item.ProductName
        item.Pno = item.ProductNo
        item.BatchNumber = BatchNumber_
        this.$set(item, 'qua', item.Quantity * this.scQuantity)
      })

      this.rubbersView = this.sumRubbers(rubbers)
      console.log(this.rubbersView, 'editRubbers_')
    },
    initProp() {
      //this.getTradeUnitList()
      //this.getwarehouseList()
      //this.getequipmentList()
      // this.pdApi
      //   .list({
      //     ProcessStage: 0,
      //     Status: 1,
      //     pageSize: this.pageParams.pageSize,
      //     pageIndex: this.pageParams.pageIndex
      //   })
      //   .then(res => {
      //     if (res.Code === 0) {
      //       // console.log("productApi res.Data", res.Data);
      //       this.DAccount = res.Data
      //       this.initDAccount = res.Data
      //       this.listTotal = res.Count
      //       this.initTotal = res.Count
      //     }
      //   })
      // this.teProcessApi.list({}).then(res => {
      //   if (res.Code === 0) {
      //     this.teProcessList = res.Data
      //   }
      // })
    },
    getequipmentList() {
      this.equipmentApi.list({ Statuses: [1, 2] }).then(res => {
        if (res.Code === 0) {
          this.equipmentList = res.Data
          console.log(this.equipmentList, 'eq')
        }
      })
    },
    getTradeUnitList() {
      this.tradeUnitApi.list({ TradeUnitTypes: [3], Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.tradeUnitList = res.Data
        }
      })
    },
    getwarehouseList() {
      this.warehouseApi.list({}).then(res => {
        if (res.Code === 0) {
          this.warehouseList = res.Data
        }
      })
    },
    // getwarehouseList() {
    //   this.warehouseApi.list({}).then(res => {
    //     if (res.Code === 0) {
    //       this.warehouseList = res.Data
    //     }
    //   })
    // },
    printed() {
      let newpage = this.$router.resolve({ path: '/clothPrint' })
      window.open(newpage.href, '_blank')
    },
    openPrint() {
      let ProductionType1 = [] // 自产
      let ProductionType2 = [] // 委外

      // 将胶件，模具，材料数据更新到本地
      localStorage.setItem('rubbers', JSON.stringify(this.rubbers))
      localStorage.setItem('mouldBoms', JSON.stringify(this.mouldBoms))
      localStorage.setItem('DetailModels', JSON.stringify(this.DetailModels))

      // 分出自产和委外的单据
      let length = this.mouldBoms.length
      for (let i = 0; i < length; ++i) {
        if (this.mouldBoms[i].ProductionType === 0) {
          ProductionType1.push(this.mouldBoms[i])
        } else if (this.mouldBoms[i].ProductionType === 1) {
          ProductionType2.push(this.mouldBoms[i])
        }
      }

      // 如果只有自产，直接打印， 如果只有委外，则还要选委外供应商

      // 只有自产
      if (ProductionType2.length === 0) {
        // 直接合并打印

        let DetailModels = JSON.parse(localStorage.getItem('DetailModels'))
        let mouldBoms = JSON.parse(localStorage.getItem('mouldBoms'))
        let rubbers = JSON.parse(localStorage.getItem('rubbers'))

        let ClothRemark = localStorage.getItem('printClothRemark')
        let OrderDate = localStorage.getItem('printOrderDate')
        let OrderProductNo = localStorage.getItem('printOrderProductNo')
        let DpName = localStorage.getItem('printDpName') || ''
        let FinishDate = localStorage.getItem('printFinishDate')
        let ProductName = localStorage.getItem('printProductName')
        let BatchNumber = localStorage.getItem('printBatchNumber')

        // 获取自产的模具信息
        let selfMouldBoms = mouldBoms.filter(item => {
          return item.ProductionType === 0
        })

        // 获取对应模具的胶件和材料
        let selfMouldBomsIds = selfMouldBoms.map(item => item.MouldBomNo)

        let selfRubbers = []
        let selfDetailModels = []

        rubbers.forEach(item => {
          if (selfMouldBomsIds.indexOf(item.MouldBomNo) !== -1) {
            selfRubbers.push(item)
          }
        })

        DetailModels.forEach(item => {
          if (selfMouldBomsIds.indexOf(item.MouldBomNo) !== -1) {
            selfDetailModels.push(...item.DetailModels)
          }
        })

        // 给胶件赋值上对应的工单号
        selfRubbers.forEach(item => {
          for (let i = 0; i < selfMouldBoms.length; ++i) {
            if (item.MouldBomNo === selfMouldBoms[i].MouldBomNo) {
              item.WorkDocNo = selfMouldBoms[i].WorkDocNo
              break
            }
          }
        })

        //  合并材料
        let sumMaterialModels = []

        let copyMaterialModels = JSON.parse(JSON.stringify(selfDetailModels))

        copyMaterialModels.forEach(item => {
          let pds = sumMaterialModels.map(item => item.ProductId)
          if (pds.indexOf(item.ProductId) === -1) {
            sumMaterialModels.push(item)
          } else {
            let length = sumMaterialModels.length
            for (let i = 0; i < length; ++i) {
              if (item.ProductId === sumMaterialModels[i].ProductId) {
                sumMaterialModels[i].Quantity = sumMaterialModels[i].Quantity + item.Quantity
                break
              }
            }
          }
        })

        let printData = {
          ClothRemark,
          OrderDate,
          OrderProductNo,
          DpName: DpName || '',
          FinishDate,
          ProductName,
          ProductModels: selfMouldBoms,
          RubberModels: selfRubbers,
          MaterialModels: selfDetailModels,
          sumMaterialModels: sumMaterialModels,
          BatchNumber
        }

        let printList = []
        printList.push(printData)

        // 缓存
        localStorage.setItem('printList', JSON.stringify(printList))

        this.printed()
      } else if (ProductionType1.length === 0) {
        // 只有委外

        let isOutsourcingShow = true
        let isSelfProducedShow = false

        // 获取 委外供应商并去重
        let outsourcingList = Array.from(
          new Set(
            ProductionType2.map((item, index) => {
              return {
                key: 'key' + index,
                name: item.ProductionDpName
              }
            })
          )
        )

        // 打开打印弹窗并设置
        this.$refs.printDialog.open().then(that => {
          that.setData({
            isOutsourcingShow,
            isSelfProducedShow,
            outsourcingList
          })
        })
      } else {
        // 自产和委外都存在

        let isOutsourcingShow = true
        let isSelfProducedShow = true

        // 获取 委外供应商并去重
        let outsourcingList = Array.from(
          new Set(
            ProductionType2.map((item, index) => {
              return {
                key: 'key' + index,
                name: item.ProductionDpName
              }
            })
          )
        )

        // 将胶件，模具，材料数据更新到本地
        localStorage.setItem('rubbers', JSON.stringify(this.rubbers))
        localStorage.setItem('mouldBoms', JSON.stringify(this.mouldBoms))
        localStorage.setItem('DetailModels', JSON.stringify(this.DetailModels))

        // 打开打印弹窗并设置
        this.$refs.printDialog.open().then(that => {
          that.setData({
            isOutsourcingShow,
            isSelfProducedShow,
            outsourcingList
          })
        })
      }

      // ProductionType
    },
    changeProcessType(row) {
      if (row.T !== 0) {
        row.T = 1
      }
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    jsonCopy(data) {
      return JSON.parse(JSON.stringify(data))
    },
    // 表格行点击，根据存货，显示对应的数据到工艺和产品子件
    rowClick(row) {
      let { index, MouldBomNo } = row
      console.log('index', index, row)

      this.currentIndex = index

      console.log('rubbersView', this.jsonCopy(this.rubbersView))

      let _itemProcessModels = []
      let _itemDetailModels = []
      let _itemrubbersView = []

      console.log('this.ProcessModels===========', this.ProcessModels)
      console.log('this.DetailModels===========', this.DetailModels)

      _itemProcessModels.push(this.ProcessModels[index])
      if (this.DetailModels[index]) {
        _itemDetailModels.push(this.DetailModels[index])
      } else {
        _itemDetailModels.push([])
      }

      _itemrubbersView = this.rubbersView.filter(item => {
        return item.MouldBomNo === MouldBomNo
      })

      this.itemProcessModels = _itemProcessModels
      this.itemDetailModels = _itemDetailModels
      this.itemrubbersView = _itemrubbersView

      console.log('this.itemProcessModels===========', this.itemProcessModels)
      console.log('this.itemDetailModels=======', this.itemDetailModels)
      console.log('this.itemrubbersView========', this.itemrubbersView)

      this.isShowTabs = true
    },
    delPro(row, i) {
      this.$confirm('确定删除这条记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        let { index } = row

        let rubbers = this.rubbersView.filter(item => {
          return item.MouldId === row.MouldId
        })
        rubbers.forEach(item => {
          if (item !== 0) {
            item.T = 2
          }
        })
        this.deltetRubbers.push(...rubbers)

        console.log('this.DetailModels', this.DetailModels)
        console.log('this.ProcessModels', this.ProcessModels)

        let detailBom = this.DetailModels.filter(item => {
          return item.id === row.MouldId + '_' + row.ColorId
        })[0]

        let dindex = this.DetailModels.findIndex(item => {
          return item.id === detailBom.id
        })

        let dindex1 = this.ProcessModels.findIndex(item => {
          return item.pid === row.MouldId + '_' + row.ColorId
        })

        this.mouldBoms.splice(index, 1)
        this.DetailModels.splice(dindex, 1)
        this.ProcessModels.splice(dindex1, 1)

        this.isShowTabs = false
      })
    },
    setList(data, dataProductId = 0) {
      console.log('setList 1') // <!-- h -->
      if (this.rubbers.length !== 0) {
        if (data.delete) {
          // 查找对应父件的index，进行删除
          let index = this.rubbers.findIndex(item => {
            return data.MouldBomNo === item.MouldBomNo
          })

          this.deltetRubbers.push(this.rubbers[index])

          this.rubbers.splice(index, 1)

          let rubbers = this.sumRubbers(this.rubbers)

          console.log('this.rubbers', rubbers)

          this.$emit('setListEnd', rubbers, 2)
        } else if (data.add) {
          if (!data.isAddList) {
            console.log('执行', data.MouldBomNo)
            // data.ChildBomNo = data.ChildBomNo;

            this.$set(data, 'T', 0)
            this.$set(data, 'Remark', '')
            this.$set(data, 'Pno', data.ProductNo)
            this.$set(data, 'Pname', data.ProductName)
            this.rubbers.push(data)

            let rubbers = this.sumRubbers(this.rubbers)

            this.$emit('setListEnd', rubbers, 1)
          } else {
            let { MouldBomNo } = data
            let bom = this.rubbers.filter(item => {
              return item.MouldBomNo === MouldBomNo
            })[0]

            console.log('data===data', data)
            console.log('bom', bom)

            bom.Pname = data.ProductName
            bom.Pno = data.ProductNo
            bom.ProductSpec = data.ProductSpec
            bom.ProcessStage = data.ProcessStage
            bom.ProduceTypeName = data.ProduceTypeName
            bom.ProductId = data.ProductId
            bom.Colors = data.Colors
            bom.PdUnitName = data.PdUnitName
            bom.PdUnitId = data.PdUnitId
            bom.UseProcess = data.UseProcess
            bom.UseColor = data.UseColor

            bom.Mould = data.Mould
            bom.MouldId = data.MouldId
            bom.MouldName = data.MouldName

            bom.DefaultSupplier = data.DefaultSupplier
            bom.ProductNature = data.ProductNature
            bom.ColorId = data.ColorId
            bom.ColorName = data.ColorName
            bom.qua = data.qua
            bom.StockQuantity = data.StockQuantity
            bom.ExistQuantity = data.ExistQuantity
            bom.MouldBomNo = data.MouldBomNo

            let rubbers = this.sumRubbers(this.rubbers)
            console.log('this.rubbers', rubbers)

            this.$emit('setListEnd', rubbers)
          }
        } else {
          let { MouldBomNo } = data
          console.log('data', data)
          let bom = this.rubbers.filter(item => {
            console.log('item', item)

            return item.MouldBomNo === MouldBomNo
          })[0]
          console.log('bom', bom)

          bom.Pname = data.ProductName
          bom.Pno = data.ProductNo
          bom.ProductSpec = data.ProductSpec
          bom.ProcessStage = data.ProcessStage
          bom.ProduceTypeName = data.ProduceTypeName
          bom.ProductId = data.ProductId
          bom.Colors = data.Colors
          bom.PdUnitName = data.PdUnitName
          bom.PdUnitId = data.PdUnitId
          bom.UseProcess = data.UseProcess
          bom.UseColor = data.UseColor
          bom.T = data.T
          bom.Mould = data.Mould
          bom.MouldId = data.MouldId
          bom.MouldName = data.MouldName

          bom.DefaultSupplier = data.DefaultSupplier
          bom.ProductNature = data.ProductNature

          bom.ColorId = data.ColorId
          bom.ColorName = data.ColorName
          bom.qua = data.qua
          bom.StockQuantity = data.StockQuantity
          bom.ExistQuantity = data.ExistQuantity
          bom.MouldBomNo = data.MouldBomNo

          let rubbers = this.sumRubbers(this.rubbers)

          this.$emit('setListEnd', rubbers)
        }

        this.rubbersView = this.sumRubbers(this.rubbers)
      }

      this.isShowTabs = false
    },
    sumRubbers(data) {
      let arr = []
      let copyData = JSON.parse(JSON.stringify(data))
      copyData.forEach(item => {
        let length = arr.length
        // console.log("length", length);
        let bool = true
        for (let i = 0; i < length; ++i) {
          // console.log("item", item);
          // console.log("arr", arr);
          if (item.MouldId === arr[i].MouldId && item.MouldBomNo === arr[i].MouldBomNo && item.ProductId === arr[i].ProductId) {
            arr[i].Quantity = arr[i].Quantity + item.Quantity
            console.log(`arr[${i}].Quantity`, arr[i].Quantity)
            arr[i].qua = arr[i].qua + item.qua
            console.log(`arr[${i}].qua`, arr[i].qua)
            bool = false
            break
          }
        }
        if (bool) {
          arr.push(item)
          // console.log("arr", arr);
        }
      })

      console.log('sumRubbers arr', arr)

      return arr
    },
    sumMould(data) {
      let arr = []
      let copyData = JSON.parse(JSON.stringify(data))
      copyData.forEach(item => {
        let length = arr.length
        // console.log("length", length);
        let bool = true
        for (let i = 0; i < length; ++i) {
          // console.log("item", item);
          // console.log("arr", arr);
          if (item.MouldId === arr[i].MouldId) {
            arr[i].Quantity = arr[i].Quantity + item.Quantity
            console.log(`arr[${i}].Quantity`, arr[i].Quantity)
            arr[i].qua = arr[i].qua + item.qua
            console.log(`arr[${i}].qua`, arr[i].qua)
            bool = false
            break
          }
        }
        if (bool) {
          arr.push(item)
          // console.log("arr", arr);
        }
      })

      console.log('sumRubbers arr', arr)

      return arr
    },
    setMould(list, type = 0) {
      let copyMouldBoms = JSON.parse(JSON.stringify(this.mouldBoms))
      list.forEach((item, i) => {
        console.log(item, 'setMould')
        item.currentProductNature = item.MouldNature
        if (item.MouldNature === 2) {
          item.MouldNature = 0
        }
        this.$set(item, 'T', copyMouldBoms[i]?.T ?? 0)
        this.$set(item, 'WorkDocId', copyMouldBoms[i]?.WorkDocId ?? 0)
        this.$set(item, 'WorkDocProductId', copyMouldBoms[i]?.WorkDocProductId ?? 0)
        this.$set(item, 'WorkDocNo', copyMouldBoms[i]?.WorkDocNo ?? '')
        this.$set(item, 'Inventory', copyMouldBoms[i]?.Inventory ?? 0)
        this.$set(item, 'SchedulingType', copyMouldBoms[i]?.SchedulingType ?? 0)
        this.$set(item, 'DpId', copyMouldBoms[i]?.DpId ?? 0)
        this.$set(item, 'MaintenanceId', copyMouldBoms[i]?.MaintenanceId ?? null)
        this.$set(item, 'ProductionType', copyMouldBoms[i]?.ProductionType ?? item.MouldNature)
        this.$set(item, 'ProductionDpId', copyMouldBoms[i]?.ProductionDpId ?? item.DefaultSupplier)
        this.$set(item, 'DocDate', copyMouldBoms[i]?.DocDate ?? this.$commonJs.getToday())
        this.$set(item, 'EndTime', copyMouldBoms[i]?.EndTime ?? this.$commonJs.getNowDatetimeString())
        this.$set(item, 'Remark', copyMouldBoms[i]?.Remark ?? '')
        this.$set(item, 'OrderProductNo', this.OrderProductNo)
        this.$set(item, 'MouldBomNo', item.MouldBomNo ?? '')
        this.$set(item, 'PickingWarehouseId', null)
        this.$set(item, 'Wages', item.Wages)
        this.$set(item, 'UnqualifiedInWarehouseId', item.UnqualifiedInWarehouseId)
        this.$set(item, 'BatchNumber', item.BatchNumber)

        console.log('item.BarCode', item.BarCode) // <!-- h -->
      })

      list.forEach(item => {
        this.$set(item, 'qua', item.Quantity)
        //if (item.DpId) {
        this.$set(item, 'showDp', true)
        this.$set(item, 'showMt', false)
        //}
        if (item.MaintenanceId) {
          this.$set(item, 'showDp', false)
          this.$set(item, 'showMt', item.ProductionType == 0)
        }
      })
      console.log('list====', list)

      this.mouldBoms = list

      let copyDetailModels = JSON.parse(JSON.stringify(this.DetailModels))
      let copyProcessModels = JSON.parse(JSON.stringify(this.ProcessModels))

      // let _ProcessModels = [];

      console.log('this.mouldBoms============================ json', JSON.parse(JSON.stringify(this.mouldBoms)))
      // this.ProcessModels = _ProcessModels;

      // let mouldBomNos = this.mouldBoms.map((item) => {
      //   return item.MouldBomNo;
      // });

      // mouldBomNos = Array.from(new Set(mouldBomNos));

      // console.log("mouldBomNos", mouldBomNos);

      let _ProcessModels = []
      let DetailDtos = []
      this.mouldBoms.forEach(item => {
        let o1 = {
          MouldName: item.MouldName,
          MouldNo: item.MouldNo,
          mouldId: item.MouldId,
          MouldBomNo: item.MouldBomNo,
          pid: item.MouldId + '_' + item.ColorId,
          ProgrammeName: item.ProcessModels[0]?.ProgrammeName ?? '',
          ProgrammeId: item.ProcessModels[0]?.ProgrammeId ?? 0,
          Processes: JSON.parse(JSON.stringify(item.ProcessModels))
        }

        _ProcessModels.push(o1)

        let o = {
          MouldName: item.MouldName,
          mouldId: item.MouldId,
          MouldBomNo: item.MouldBomNo,
          id: item.MouldId + '_' + item.ColorId,
          mouldQua: item.mouldQua,
          mouldqua: item.qua,
          DetailModels: JSON.parse(JSON.stringify(item.DetailDtos))
        }

        DetailDtos.push(o)
      })

      this.ProcessModels = _ProcessModels

      DetailDtos.forEach(item => {
        let temp = copyDetailModels.filter(v => {
          return v.MouldBomNo === item.MouldBomNo
        })[0]?.DetailModels

        // console.log("====temp===", temp);

        item.DetailModels.forEach((v, i) => {
          // let restQua = list.filter((v1) => {
          //   console.log("===========v1====", v1);
          //   return v1.MouldBomNo === item.MouldBomNo;
          // })[0]?.Quantity;

          // console.log("restQua==========", restQua);

          // console.log(
          //   "v.Quantity",
          //   v.Quantity,
          //   "item.mouldQua",
          //   item.mouldQua,
          //   "v.Quantity  / item.mouldQua",
          //   v.Quantity / item.mouldQua
          // );

          v.Pno = v.ProductNo
          v.Pname = v.ProductName
          v.T = temp ? temp[i]?.T : 0
          v.WorkDocMaterialId = temp ? temp[i]?.WorkDocMaterialId : 0
          v.WorkDocId = temp ? temp[i]?.WorkDocId : 0
          v.Ration = temp ? temp[i]?.Ration : 0
          v.RationUnit = temp ? temp[i]?.RationUnit : 0
          v.Rate = temp ? temp[i]?.Rate : 0
          v.Loss = temp ? temp[i]?.Loss : 0
          v.rateQua = parseFloat((v.Quantity / item.mouldQua).toFixed(4))
          v.PdUnitName = v.UnitName
          //this.$set(v, "qua", Math.ceil(v.Quantity * this.scQuantity));
          this.$set(v, 'qua', Math.ceil(item.mouldqua * v.rateQua))
        })
      })

      this.DetailModels = DetailDtos

      console.log('结果=========this.DetailModels====', this.DetailModels)
    },
    clearData() {
      this.mouldBoms = []
      this.ProcessModels = []
      this.DetailModels = []
    },
    changeT(data, type = 0) {
      if (type === 0) {
        data.forEach(item => {
          item.T = null
        })
      } else if (type === 1) {
        data.forEach(item => {
          item.DetailModels.forEach(v => {
            v.T = null
          })
        })
      } else if (type === 2) {
        data.forEach(item => {
          item.T = null
          item.Processes.forEach(v => {
            v.T = 1
          })
        })
      }
    },
    selectCome(row) {
      if (row.TradeUnitName == null) {
        this.$set(row, 'TradeUnitName', '')
      }
      console.log('row', row)
      this.currentRow = row
      this.$refs.comeListDialog.open().then(that => {
        that.getData({ TradeUnitType: 3 })
      })
    },

    listDialogSelect(list) {
      let deleteProcessModels = JSON.parse(JSON.stringify(this.programmeCurrentRow))
      if (deleteProcessModels.Processes.length !== 0 && deleteProcessModels.Processes[0].T === 1) {
        deleteProcessModels.Processes.forEach(item => {
          item.T = 2
        })

        this.deleteProcess.push(...deleteProcessModels.Processes)

        console.log('this.deleteProcess', this.deleteProcess)
      }

      list.Processes.forEach(item => {
        item.ProcessType = null
        item.DpId = 0
        item.TradeUnitName = ''
      })

      this.programmeCurrentRow.Processes = list.Processes
      this.programmeCurrentRow.ProgrammeId = list.ProgrammeId
      this.programmeCurrentRow.ProgrammeName = list.ProgrammeName
      if (this.programmeCurrentIndex != null && this.mouldBoms[this.programmeCurrentIndex].T !== 0) {
        this.mouldBoms[this.programmeCurrentIndex].T = 1
      }

      // let item = this.Products.filter(item => {
      //   return item.ProductId === this.programmeCurrentRow.pid;
      // })
      // item.ProgrammeId = list.ProgrammeId;
      let copyProcessModels = JSON.parse(JSON.stringify(this.ProcessModels))
      this.ProcessModels = []
      this.$nextTick(() => {
        this.ProcessModels = copyProcessModels
        let arr = []
        arr.push(this.ProcessModels[this.currentIndex])
        this.itemProcessModels = arr
      })
    },
    detail_saved(list) {
      this.programmeCurrentRow.Processes = list

      console.log('this.ProcessModels', this.ProcessModels)
    },
    changeProgramme(row, index) {
      this.programmeCurrentRow = row
      this.programmeCurrentIndex = index
      this.$refs.listDialog.open()
    },
    changeProgrammeInfo(row) {
      this.programmeCurrentRow = row
      row.Pname = row.MouldName
      this.$refs.detailDialog.open().then(that => {
        that.setTableData(row)
      })
    },
    changeColor(val, row) {
      if (this.editType === 1 && row.T !== 0) {
        row.T = 1
      }
      let item = row.Colors.filter(item => {
        return item.ColorId === val
      })[0]

      row.ColorName = item.ColorName
    },
    changeQua(val, row) {
      if (this.editType === 1 && row.T !== 0) {
        row.T = 1
      }
      val = parseFloat(val)
      if (row.Quantity) {
        row.Quantity = val / this.scQuantity
      }
      row.qua = val
    },
    onSelect(e, row) {
      console.log('e1111111111111111', e)
      if (this.editType === 1 && row.T !== 0) {
        row.T = 1
      }
      row.ColorId = 0
      this.$set(row, 'Pname', e.ProductName)
      this.$set(row, 'Pno', e.ProductNo)
      row.ProductName = e.ProductName
      row.ProductNo = e.ProductNo
      row.ProductSpec = e.ProductSpec
      row.ProcessStage = e.ProcessStage
      row.ProcessStageName = e.ProcessStageName
      row.ProduceTypeName = e.ProduceTypeName
      row.ProductId = e.ProductId
      row.Colors = e.Colors
      row.PdUnitName = e.PdUnitName
      row.PdUnitId = e.PdUnitId
      row.UseProcess = e.UseProcess
      row.UseColor = e.UseColor

      row.Mould = e.Mould
      row.MouldId = e.MouldId
      row.MouldName = e.MouldName

      row.DefaultSupplier = e.DefaultSupplier
      row.MouldNature = e.MouldNature
      row.StockQuantity = e.StockQuantity
      row.ExistQuantity = e.ExistQuantity
    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage({ val, text1 }) {
      this.pageParams.pageIndex = val
      this.pdApi.list({ pageIndex: val, pageSize: 7, ProductName: text1, ProcessStage: 0, Status: 1 }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data
          this.listTotal = res.Count
        }
      })
    },
    inputText(text) {
      this.pdApi.list({ pageIndex: 1, pageSize: 7, ProductName: text }).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data
          this.listTotal = res.Count
        }
      })
    },
    tabChange(e) {
      if (e.index === '1') {
        this.sumTableData = []
        let arr = []
        this.DetailModels.forEach(item => {
          arr.push(...item.DetailModels)
        })
        this.sumTableData = this.sumRubbers(arr)
      }
    },
    add(item) {
      this.resetFun()
      let temp_pname = item.Pname
      let vitem = this.mouldBoms.filter(v => {
        return temp_pname === v.Pname
      })[0]

      let TeProductId = vitem.TeProductId
      let TebomId = vitem.TebomId
      let o = {
        T: 0,
        WorkDocId: 0,
        WorkDocNo: '',
        WorkDocMaterialId: 0,
        Pno: '',
        Pname: '',
        ProductId: 0,
        ImgUrl: '',
        ProductSpec: '',
        PdUnitId: 0,
        PdUnitName: '',
        ColorId: 0,
        ColorName: '',
        Quantity: '',
        ProcessStage: '',
        ProduceTypeName: '',
        StockQuantity: '',
        ExistQuantity: '',
        PickingQuantity: '',
        ConsumeQuantity: '',
        Property: 0,
        PropertyName: '',
        Loss: 0,
        Rate: 0,
        Ration: 0,
        RationUnit: 0,
        TeProductId,
        TebomId,
        qua: 0
      }
      this.DetailModels[this.currentIndex].DetailModels.push(o)
    },
    comeSelect(row) {
      console.log(row, 'row')
      console.log(this.currentRow, 'currentRow')
      this.currentRow.DpId = row.TradeUnitId
      this.currentRow.TradeUnitName = row.FullName
      this.currentRow.FullName = row.FullName
      if (this.currentRow.T !== 0) {
        this.currentRow.T = 1
      }
    },
    editT(row) {
      // if(this.editType === 1 && row.T !== 0){
      //   row.T = 1;
      // }
    },
    changeSchedulingType(val, row) {
      this.editT(row)
      if (val === 0) {
        row.DpId = 0
        row.MaintenanceId = null
        row.showDp = true
        row.showMt = false
      } else if (val === 1) {
        row.DpId = 0
        row.MaintenanceId = null
        row.showDp = false
        row.showMt = row.ProductionType == 0
      }
    },
    // 修改模具数量
    changePQuantity(val, row) {
      let { index } = row
      let detailModels = this.DetailModels[index].DetailModels
      console.log('detailModels', detailModels)

      if (row.T !== 0) {
        row.T = 1
      }

      if (detailModels.length !== 0) {
        detailModels.forEach(item => {
          if (item.T !== 0) {
            item.T = 1
          }
          item.qua = val * item.rateQua
        })
      }
      if (row.MaintenanceId) {
        this.getCapacity(row.MaintenanceId, row)
      }
      console.log('=====this.mouldData============', this.mouldData, row, this.mouldData['_' + row.MouldBomNo])
      if (this.mouldData['_' + row.MouldBomNo] == null) {
        this.teMouldBomApi.bomList({ BomNo: row.MouldBomNo, IsEqBomNo: true }).then(res => {
          if (res.Code === 0) {
            let BomRubbers = res.Data[0].BomRubbers
            this.mouldData['_' + row.MouldBomNo] = BomRubbers

            let rubbers = BomRubbers

            if (rubbers.length > 0) {
              this.rubbersView = this.sumRubbers(this.rubbers)

              this.rubbersView.forEach(item => {
                let o = rubbers.filter(v => {
                  console.log('item.ProductId', item.ProductId)
                  console.log('v.ProductId', v.ProductId)

                  return item.ProductId === v.ProductId
                })[0]

                console.log('o==========', o)
                if (o) {
                  if (item.T !== 0) {
                    item.T = 1
                  }
                  item.qua = o.Quantity * val
                }
              })

              let _itemrubbersView = []

              _itemrubbersView = this.rubbersView.filter(item => {
                return item.MouldBomNo === row.MouldBomNo
              })

              this.itemrubbersView = _itemrubbersView
            }
          }
        })
      } else {
        if (this.mouldData['_' + row.MouldId] != null) {
          let rubbers = this.mouldData['_' + row.MouldId].Rubbers
          if (rubbers.length > 0) {
            this.rubbersView = this.sumRubbers(this.rubbers)

            this.rubbersView.forEach(item => {
              let o = rubbers.filter(v => {
                return item.ProductId === v.ProductId
              })[0]
              item.qua = o.Quantity * val
            })

            let _itemrubbersView = []
            _itemrubbersView = this.rubbersView.filter(item => {
              return item.MouldId === row.MouldId
            })
            this.itemrubbersView = _itemrubbersView
          }
        }
      }
    },
    del(item, index) {
      this.$confirm('确定删除这条记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        if (this.editType === 1 && row.T !== 0) {
          row.T = 2
          this.deleteLineDetailModels.push(row)
        }
        item.DetailModels.splice(index, 1)
      })
    },
    base64ToFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    async viewImg(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg)
      const ImgUrl = res.Data
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！')
      let imgs = []
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl))
        // imgs.push(imgBlob)
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs
      this.$refs.imgDialog.open()
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday()
      var start = ''
      var end = ''
      switch (t) {
        case '今天':
          start = today
          end = today
          break
        case '昨天':
          start = this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD')
          end = start
          break
        case '近3天':
          start = this.$dayjs().subtract(2, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '近7天':
          start = this.$dayjs().subtract(6, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '近14天':
          start = this.$dayjs().subtract(13, 'day').format('YYYY-MM-DD')
          end = today
          break
        case '本周':
          start = this.$dayjs().startOf('week').format('YYYY-MM-DD')
          end = today
          break
        case '上周':
          var week = this.$dayjs().subtract(1, 'week')
          start = week.startOf('week').format('YYYY-MM-DD')
          end = week.endOf('week').format('YYYY-MM-DD')
          break
        case '本月':
          start = this.$dayjs().startOf('month').format('YYYY-MM-DD')
          end = today
          break
        case '上月':
          var month = this.$dayjs().subtract(1, 'month')
          start = month.startOf('month').format('YYYY-MM-DD')
          end = month.endOf('month').format('YYYY-MM-DD')
          break
        case '本季':
          start = this.$dayjs().startOf('quarter').format('YYYY-MM-DD')
          end = today
          break
        case '上季':
          var quarter = this.$dayjs().subtract(1, 'quarter')
          start = quarter.startOf('quarter').format('YYYY-MM-DD')
          end = quarter.endOf('quarter').format('YYYY-MM-DD')
          break
        case '本年':
          start = this.$dayjs().startOf('year').format('YYYY-MM-DD')
          end = today
          break
        case '上年':
          var year = this.$dayjs().subtract(1, 'year')
          start = year.startOf('year').format('YYYY-MM-DD')
          end = year.endOf('year').format('YYYY-MM-DD')
          break
      }

      return {
        start,
        end
      }
    },
    filterData(data) {
      return data.filter(item => {
        return item.T != null
      })
    },
    saveBofore() {
      let saveMouldBoms = []
      let saveProcess = []
      let saveDetail = []

      let copyMouldBomsIds = this.copyMouldBoms.map(item => {
        return item.MouldId + '_' + item.ColorId
      })
      let mouldBoms1 = JSON.parse(JSON.stringify(this.mouldBoms))
      let mouldBomsIds = mouldBoms1.map(item => {
        return item.MouldId + '_' + item.ColorId
      })
      // 模具在 this.mouldBoms 存在， copyMouldBoms 不存在 ，则为新增
      let mouldAdd = mouldBoms1.filter(item => {
        return copyMouldBomsIds.indexOf(item.MouldId + '_' + item.ColorId) === -1
      })

      // 模具在 this.mouldBoms 不存在， copyMouldBoms 存在 ，则为删除
      let mouldDelete = this.copyMouldBoms.filter(item => {
        return mouldBomsIds.indexOf(item.MouldId + '_' + item.ColorId) === -1
      })

      let mouldEdit = mouldBoms1.filter(item => {
        return copyMouldBomsIds.indexOf(item.MouldId + '_' + item.ColorId) !== -1
      })

      mouldAdd.forEach(item => {
        item.T = 0
      })
      console.log('mouldAdd', mouldAdd)

      mouldEdit.forEach(item => {
        item.T = 1
      })
      console.log('mouldEdit', mouldEdit)

      mouldDelete.forEach(item => {
        item.T = 2
      })
      console.log('mouldDelete', mouldDelete)

      let _arr = []

      _arr.push(...mouldEdit)
      _arr.push(...mouldAdd)
      _arr.push(...mouldDelete)
      saveMouldBoms = _arr

      console.log('this.copyProcessModels', this.copyProcessModels)
      let copyProcessModelsIds = this.copyProcessModels.map(item => {
        return item.pid
      })
      let ProcessModels1 = JSON.parse(JSON.stringify(this.ProcessModels))
      console.log('ProcessModels1', ProcessModels1)

      let ProcessModelsIds = ProcessModels1.map(item => {
        return item.pid
      })

      // 模具在 this.mouldBoms 存在， copyMouldBoms 不存在 ，则为新增
      let processAdd = ProcessModels1.filter(item => {
        return copyProcessModelsIds.indexOf(item.pid) === -1
      })
      console.log('processAdd', processAdd)

      // 模具在 this.mouldBoms 不存在， copyMouldBoms 存在 ，则为删除
      let processDelete = this.copyProcessModels.filter(item => {
        return ProcessModelsIds.indexOf(item.pid) === -1
      })
      console.log('processDelete', processDelete)

      let processEdit = ProcessModels1.filter(item => {
        return copyProcessModelsIds.indexOf(item.pid) !== -1
      })
      console.log('processEdit', processEdit)

      processAdd.forEach(item => {
        item.Processes.forEach(v => {
          v.T = 0
        })
      })

      processDelete.forEach(item => {
        item.Processes.forEach(v => {
          v.T = 2
        })
      })

      _arr = []
      _arr.push(...processEdit)
      _arr.push(...processAdd)
      _arr.push(...processDelete)
      saveProcess = _arr

      let copyDetailModelsIds = this.copyDetailModels.map(item => {
        return item.id
      })
      let DetailModels1 = JSON.parse(JSON.stringify(this.DetailModels))
      let DetailModels = DetailModels1.map(item => {
        return item.id
      })

      // 模具在 this.mouldBoms 存在， copyMouldBoms 不存在 ，则为新增
      let detailAdd = DetailModels1.filter(item => {
        console.log('item', item)
        return copyDetailModelsIds.indexOf(item.id) === -1
      })
      console.log('detailAdd', detailAdd)
      // 模具在 this.mouldBoms 不存在， copyMouldBoms 存在 ，则为删除
      let detailDelete = this.copyDetailModels.filter(item => {
        return DetailModels.indexOf(item.id) === -1
      })
      console.log('detailDelete', detailDelete)

      let detailEdit = DetailModels1.filter(item => {
        return copyDetailModelsIds.indexOf(item.id) !== -1
      })

      console.log('detailEdit', detailEdit)

      // detailEdit.forEach((item) => {
      //   item.DetailModels = item.DetailModels.filter((item) => {
      //     return item.T != null;
      //   });
      // });

      detailAdd.forEach(item => {
        item.DetailModels.forEach(v => {
          v.T = 0
        })
      })

      detailEdit.forEach(item => {
        item.DetailModels.forEach(v => {
          v.T = 1
        })
      })

      detailDelete.forEach(item => {
        item.DetailModels.forEach(v => {
          v.T = 2
        })
      })

      _arr = []
      _arr.push(...detailEdit)
      _arr.push(...detailAdd)
      _arr.push(...detailDelete)
      saveDetail = _arr

      // 匹配
      let saveMouldBomsTemp = []
      let saveProcessTemp = []
      let saveDetailTemp = []

      saveMouldBoms.forEach(item => {
        saveMouldBomsTemp.push(item)
        let process = saveProcess.filter(v => {
          return v.pid === item.MouldId + '_' + item.ColorId
        })
        saveProcessTemp.push(...process)

        let detail = saveDetail.filter(v => {
          return v.id === item.MouldId + '_' + item.ColorId
        })
        saveDetailTemp.push(...detail)
      })

      console.log('注塑信息', {
        mouldBoms: saveMouldBomsTemp,
        ThisProcessModels: saveProcessTemp,
        ThisDetailModels: saveDetailTemp
      })

      return {
        mouldBoms: saveMouldBomsTemp,
        ThisProcessModels: saveProcessTemp,
        ThisDetailModels: saveDetailTemp
      }
    },
    sendData() {
      // 检查必填项目
      let keys = [] // 必填的字段
      // SchedulingType DpId MaintenanceId ProductionType  ProductionDpId
      this.mouldBoms.forEach(item => {
        if (!this.QuickProcess && item.SchedulingType == null) {
          keys.push({ name: item.MouldName, id: item.MouldId, key: '排产类型' })
        } else if (item.SchedulingType === 0 && (item.DpId == null || item.DpId == 0) && !this.QuickProcess) {
          keys.push({ name: item.MouldName, id: item.MouldId, key: '部门' })
        } else if (item.SchedulingType === 1 && (item.MaintenanceId == null || item.MaintenanceId == 0) && !this.QuickProcess) {
          keys.push({ name: item.MouldName, id: item.MouldId, key: '设备' })
        }
        if (item.ProductionType !== 0 && item.ProductionDpId == null) {
          keys.push({ name: item.ProductName, id: item.ProductId, key: '供应商' })
        }
      })

      if (keys.length !== 0) {
        // 构造提示信息
        let arr = Array.from(
          new Set(
            keys.map(item => {
              return item.id
            })
          )
        )

        let msgArr2d = []
        arr.forEach(item => {
          msgArr2d.push(
            keys.filter(v => {
              return v.id === item
            })
          )
        })

        let msgArr = []
        msgArr2d.forEach(item => {
          let name = item[0].name
          let keyStr = item
            .map(v => {
              return v.key
            })
            .join(',')
          msgArr.push(`请填写注塑工单模具${name}一列中的${keyStr}`)
        })

        let msg = msgArr.join('<br/>')
        this.$message({ type: 'warning', message: msg, dangerouslyUseHTMLString: true })

        return { arr: false, RubberModels: false }
      }

      let arr = []

      if (this.editType !== 1) {
        let length = this.mouldBoms.length

        for (let i = 0; i < length; ++i) {
          let ProductModels = []
          let ProcessModels = []
          let MaterialModels = []

          // 对默认值进行设置
          console.log('this.ProcessModels[i]?.ProgrammeId', this.ProcessModels[i]?.ProgrammeId)
          let o = {
            T: this.mouldBoms[i].T,
            WorkDocProductId: this.mouldBoms[i].WorkDocProductId,
            WorkDocId: this.mouldBoms[i].WorkDocId,
            MouldId: this.mouldBoms[i].MouldId,
            ProgrammeId: this.ProcessModels[i]?.ProgrammeId ?? 0,
            ColorId: this.mouldBoms[i].ColorId ?? 0,
            Quantity: this.mouldBoms[i].qua,
            TeProductId: this.mouldBoms[i].TeProductId ?? 0,
            Inventory: this.mouldBoms[i].Inventory,
            // StockQuantity: this.mouldBoms[i].StockQuantity,
            // ExistQuantity: this.mouldBoms[i].ExistQuantity,
            SourceDtsId: 0,
            // RpType: this.mouldBoms[i].ProcessStage,
            RpRequirement: this.mouldBoms[i].RpRequirement ?? '',
            SnType: this.mouldBoms[i].SnType ?? 0,
            Loss: this.mouldBoms[i].Loss ?? 0,
            Status: this.mouldBoms[i].Status ?? 0,
            OrderNo: this.mouldBoms[i].OrderProductNo,
            WorkDocNo: this.mouldBoms[i].WorkDocNo,
            MouldBomNo: this.mouldBoms[i].MouldBomNo,
            TemouldBomId: this.mouldBoms[i].TemouldBomId,
            Wages: this.mouldBoms[i].Wages,
            UnqualifiedInWarehouseId: this.mouldBoms[i].UnqualifiedInWarehouseId
          }

          ProductModels.push(o)

          console.log('ProductModels', ProductModels)

          this.ProcessModels[i]?.Processes.forEach(item => {
            let o = {
              T: item.T,
              ProgrammeId: item.ProgrammeId,
              ProcessType: item.ProcessType,
              DpId: item.DpId ?? 0,
              WorkDocProcessId: item.WorkDocProcessId ?? 0,
              WorkDocId: this.mouldBoms[i].WorkDocId ?? 0,
              ProcessId: item.ProcessId,
              ProcessSn: item.ProcessSn,
              SnType: item.SnType ?? 0,
              ConvertRatio: item.ConvertRatio ?? 1,
              MachineId: item.MachineId ?? 0,
              Length: item.Length ?? 0,
              Width: item.Width ?? 0,
              Multiple: item.Multiple ?? 0,
              RatedLoss: item.RatedLoss ?? 0,
              LossRate: item.LossRate ?? 0,
              PlanIn: item.PlanIn ?? 0,
              PlanOut: item.PlanOut ?? 0,
              PlanOutUnit: item.PlanOutUnit ?? '',
              Requirement: item.Requirement ?? '',
              Status: item.Status ?? 0
            }
            ProcessModels.push(o)
          })

          console.log('ProcessModels', ProcessModels)

          this.DetailModels[i]?.DetailModels.forEach(item => {
            let o = {
              T: item.T,
              WorkDocMaterialId: item.WorkDocMaterialId,
              WorkDocId: this.mouldBoms[i].WorkDocId,
              ProductId: item.ProductId,
              ColorId: item.ColorId ?? 0,
              Ration: item.Ration,
              RationUnit: item.RationUnit,
              Quantity: item.qua,
              QuantityUnit: item.PdUnitId ? item.PdUnitId : item.UnitId,
              PropertyId: item.PropertyId ?? 0,
              Rate: item.Rate,
              Loss: item.Loss,
              ChildTeProductId: item.ChildTeProductId ?? 0,
              TeProductId: item.TeProductId ?? 0
            }
            MaterialModels.push(o)
          })
          console.log('MaterialModels', MaterialModels)

          let {
            WorkDocId,
            WorkDocNo = '',
            SchedulingType = 0,
            DpId = 0,
            MaintenanceId = 0,
            ProductionType,
            ProductionDpId = 0,
            DocDate,
            EndTime,
            Remark = '',
            qua,
            Inventory,
            StartTime,
            PickingWarehouseId = PickingWarehouseId ?? 0,
            Wages,
            UnqualifiedInWarehouseId = UnqualifiedInWarehouseId ?? 0
          } = this.mouldBoms[i]
          if (DpId == null) {
            DpId = 0
          }
          if (MaintenanceId == null) {
            MaintenanceId = 0
          }
          let { start } = this.cycleChange('今天')
          if (StartTime) {
            start = StartTime
          }
          SchedulingType = SchedulingType ?? 0
          DpId = DpId ?? 0
          MaintenanceId = MaintenanceId ?? 0
          ProductionDpId = ProductionDpId ?? 0
          let Quantity = qua - Inventory > 0 ? qua - Inventory : qua

          let data = {
            Stage: 0,
            WorkDocType: 0,
            ProductType: 0,
            StartTime: start,
            WorkDocId,
            WorkDocNo,
            EndTime,
            SchedulingType,
            DpId,
            MaintenanceId,
            ProductionType,
            ProductionDpId,
            DocDate,
            Remark,
            Quantity,
            PickingWarehouseId: PickingWarehouseId ?? 0,
            Wages,
            batchShowEndTime: this.batchShowEndTime,
            UnqualifiedInWarehouseId: UnqualifiedInWarehouseId ?? 0
          }

          ProductModels = this.filterData(ProductModels)
          ProcessModels = this.filterData(ProcessModels)
          MaterialModels = this.filterData(MaterialModels)

          let o1 = {
            ProductModels,
            ProcessModels,
            MaterialModels,
            ...data
          }

          arr.push(o1)
        }
      }

      if (this.editType === 1) {
        let { mouldBoms, ThisProcessModels, ThisDetailModels } = this.saveBofore()

        let length = mouldBoms.length

        for (let i = 0; i < length; ++i) {
          let ProductModels = []
          let ProcessModels = []
          let MaterialModels = []

          // 对默认值进行设置
          let o = {
            T: mouldBoms[i].T,
            WorkDocProductId: mouldBoms[i].WorkDocProductId,
            WorkDocId: mouldBoms[i].WorkDocId,
            MouldId: mouldBoms[i].MouldId,
            ProgrammeId: ThisProcessModels[i]?.ProgrammeId ?? 0,
            ColorId: mouldBoms[i].ColorId ?? 0,
            Quantity: mouldBoms[i].qua,
            TeProductId: mouldBoms[i].TeProductId ?? 0,
            Inventory: mouldBoms[i].Inventory,
            SourceDtsId: 0,
            // RpType: mouldBoms[i].ProcessStage,
            RpRequirement: mouldBoms[i].RpRequirement ?? '',
            SnType: mouldBoms[i].SnType ?? 0,
            Loss: mouldBoms[i].Loss ?? 0,
            Status: mouldBoms[i].Status ?? 0,
            OrderNo: mouldBoms[i].OrderProductNo,
            WorkDocNo: mouldBoms[i].WorkDocNo,
            MouldBomNo: mouldBoms[i].MouldBomNo,
            TemouldBomId: mouldBoms[i].TemouldBomId
          }

          ProductModels.push(o)

          console.log('ProductModels', ProductModels)

          ThisProcessModels[i]?.Processes.forEach(item => {
            let o = {
              T: item.T,
              ProgrammeId: item.ProgrammeId,
              ProcessType: item.ProcessType,
              DpId: item.DpId ?? 0,
              WorkDocProcessId: item.WorkDocProcessId ?? 0,
              WorkDocId: mouldBoms[i].WorkDocId ?? 0,
              ProcessId: item.ProcessId,
              ProcessSn: item.ProcessSn,
              SnType: item.SnType ?? 0,
              ConvertRatio: item.ConvertRatio ?? 1,
              MachineId: item.MachineId ?? 0,
              Length: item.Length ?? 0,
              Width: item.Width ?? 0,
              Multiple: item.Multiple ?? 0,
              RatedLoss: item.RatedLoss ?? 0,
              LossRate: item.LossRate ?? 0,
              PlanIn: item.PlanIn ?? 0,
              PlanOut: item.PlanOut ?? 0,
              PlanOutUnit: item.PlanOutUnit ?? '',
              Requirement: item.Requirement ?? '',
              Status: item.Status ?? 0
            }
            ProcessModels.push(o)
          })

          let _Processes = this.deleteProcess.filter(item => {
            return item.WorkDocId === mouldBoms[i].WorkDocId
          })

          _Processes.forEach(item => {
            let o = {
              T: 2,
              ProgrammeId: item.ProgrammeId,
              ProcessType: item.ProcessType,
              DpId: item.DpId ?? 0,
              WorkDocProcessId: item.WorkDocProcessId ?? 0,
              WorkDocId: item.WorkDocId ?? 0,
              ProcessId: item.ProcessId,
              ProcessSn: item.ProcessSn,
              SnType: item.SnType ?? 0,
              ConvertRatio: item.ConvertRatio ?? 1,
              MachineId: item.MachineId ?? 0,
              Length: item.Length ?? 0,
              Width: item.Width ?? 0,
              Multiple: item.Multiple ?? 0,
              RatedLoss: item.RatedLoss ?? 0,
              LossRate: item.LossRate ?? 0,
              PlanIn: item.PlanIn ?? 0,
              PlanOut: item.PlanOut ?? 0,
              PlanOutUnit: item.PlanOutUnit ?? '',
              Requirement: item.Requirement ?? '',
              Status: item.Status ?? 0
            }
            ProcessModels.push(o)
          })

          console.log('ProcessModels', ProcessModels)

          ThisDetailModels[i]?.DetailModels.forEach(item => {
            let o = {
              T: item.T,
              WorkDocMaterialId: item.WorkDocMaterialId,
              WorkDocId: mouldBoms[i].WorkDocId,
              ProductId: item.ProductId,
              ColorId: item.ColorId ?? 0,
              Ration: item.Ration,
              RationUnit: item.RationUnit,
              Quantity: item.qua,
              QuantityUnit: item.PdUnitId,
              PropertyId: item.PropertyId ?? 0,
              Rate: item.Rate,
              Loss: item.Loss,
              ChildTeProductId: item.ChildTeProductId ?? 0,
              TeProductId: item.TeProductId ?? 0
            }
            MaterialModels.push(o)
          })
          console.log('MaterialModels', MaterialModels)

          let {
            WorkDocId,
            WorkDocNo = '',
            SchedulingType = 0,
            DpId = 0,
            MaintenanceId = 0,
            ProductionType,
            ProductionDpId = 0,
            DocDate,
            EndTime,
            Remark = '',
            qua,
            Inventory,
            StartTime,
            PickingWarehouseId = PickingWarehouseId ?? 0,
            Wages,
            UnqualifiedInWarehouseId = UnqualifiedInWarehouseId ?? 0
          } = mouldBoms[i]
          if (DpId == null) {
            DpId = 0
          }
          if (MaintenanceId == null) {
            MaintenanceId = 0
          }
          let { start } = this.cycleChange('今天')
          if (StartTime) {
            start = StartTime
          }
          SchedulingType = SchedulingType ?? 0
          DpId = DpId ?? 0
          MaintenanceId = MaintenanceId ?? 0
          ProductionDpId = ProductionDpId ?? 0
          let Quantity = qua - Inventory > 0 ? qua - Inventory : qua

          let data = {
            Stage: 0,
            WorkDocType: 0,
            ProductType: 0,
            StartTime: start,
            WorkDocId,
            WorkDocNo,
            EndTime,
            SchedulingType,
            DpId,
            MaintenanceId,
            ProductionType,
            ProductionDpId,
            DocDate,
            Remark,
            Quantity,
            PickingWarehouseId: PickingWarehouseId ?? 0,
            Wages,
            batchShowEndTime: this.batchShowEndTime,
            UnqualifiedInWarehouseId: UnqualifiedInWarehouseId ?? 0
          }

          ProductModels = this.filterData(ProductModels)
          ProcessModels = this.filterData(ProcessModels)
          MaterialModels = this.filterData(MaterialModels)

          let o1 = {
            ProductModels,
            ProcessModels,
            MaterialModels,
            ...data
          }

          arr.push(o1)
        }
      }

      let RubberModels = []
      if (this.editType !== 1) {
        this.rubbersView.forEach(item => {
          let o = {
            T: 0,
            WorkRubberId: item.WorkRubberId,
            OrderId: item.OrderId,
            OrderProductId: item.OrderProductId,
            ProductId: item.ProductId,
            ColorId: item.ColorId,
            Property: item.PropertyId,
            Quantity: item.qua,
            InQuantity: item.InQuantity,
            Remarks: item.Remarks,
            ChildTeProductId: item.ChildTeProductId ?? 0,
            TeProductId: item.TeProductId ?? 0,
            MouldBomNo: item.MouldBomNo,
            ChildGroupNo: item.add ? item.ChildBomNo : item.ChildGroupNo ? item.ChildGroupNo : ''
          }

          RubberModels.push(o)
        })
      } else {
        this.rubbersView.forEach(item => {
          let o = {
            T: item.add ? 0 : item.T,
            WorkRubberId: item.WorkRubberId,
            OrderId: item.OrderId,
            OrderProductId: item.OrderProductId,
            ProductId: item.ProductId,
            ColorId: item.ColorId,
            Property: item.PropertyId,
            Quantity: item.qua,
            InQuantity: item.InQuantity,
            Remarks: item.Remarks,
            ChildTeProductId: item.ChildTeProductId ?? 0,
            TeProductId: item.TeProductId ?? 0,
            MouldBomNo: item.MouldBomNo,
            ChildGroupNo: item.add ? item.ChildBomNo : item.ChildGroupNo ? item.ChildGroupNo : ''
          }

          RubberModels.push(o)
        })

        this.deltetRubbers.forEach(item => {
          let o = {
            T: 2,
            WorkRubberId: item.WorkRubberId,
            OrderId: item.OrderId,
            OrderProductId: item.OrderProductId,
            ProductId: item.ProductId,
            ColorId: item.ColorId,
            Property: item.PropertyId,
            Quantity: item.qua,
            InQuantity: item.InQuantity,
            Remarks: item.Remarks,
            ChildTeProductId: item.ChildTeProductId ?? 0,
            TeProductId: item.TeProductId ?? 0,
            MouldBomNo: item.MouldBomNo,
            ChildGroupNo: item.add ? item.ChildBomNo : item.ChildGroupNo ? item.ChildGroupNo : ''
          }

          RubberModels.push(o)
        })
      }

      RubberModels = this.filterData(RubberModels)

      return { RubberModels, arr }
    },
    setDetailModels(glueData, mouldData) {
      console.log('glueData****', JSON.parse(JSON.stringify(glueData)))
      glueData = JSON.parse(JSON.stringify(glueData))
      mouldData = JSON.parse(JSON.stringify(mouldData))

      let r = []

      let pds = this.rubbers.map(item => {
        return item.ProductId
      })

      glueData.forEach(item => {
        let index = pds.indexOf(item.ProductId)

        if (index !== -1 && this.rubbers[index].WorkRubberId) {
          this.rubbers[index].qua = item.qua
          this.rubbers[index].T = 1
          r.push(this.rubbers[index])
        } else if (index === -1 || this.rubbers[index].WorkRubberId == 0) {
          item.InQuantity = 0
          item.WorkRubberId = 0
          item.T = 0
          r.push(item)
        }

        console.log('==========r=======', r)
      })

      // if(this.editType === 0){
      //   r.forEach(item => {
      //     item.T = 0;
      //   })
      // }else{
      //   r.forEach(item => {
      //     item.T = 1;
      //   })
      // }

      r.forEach(item => {
        item.Quantity = item.qua
      })

      this.rubbers = r

      console.log('this.rubbers', this.rubbers)

      let mouldBomsIds = this.mouldBoms.map(item => {
        return item.MouldId
      })

      mouldData.forEach(item => {
        let index = mouldBomsIds.indexOf(item.MouldId)

        if (index !== -1) {
          if (this.editType === 0) {
            this.$set(item, 'T', 0)
          } else {
            this.$set(item, 'T', null)
          }
          this.$set(item, 'WorkDocId', this.mouldBoms[index].WorkDocId)
          this.$set(item, 'WorkDocProductId', this.mouldBoms[index].WorkDocProductId)
          this.$set(item, 'WorkDocNo', this.mouldBoms[index].WorkDocNo)
          this.$set(item, 'Inventory', this.mouldBoms[index].Inventory)
          this.$set(item, 'SchedulingType', this.mouldBoms[index].SchedulingType)
          this.$set(item, 'DpId', this.mouldBoms[index].DpId)
          this.$set(item, 'MaintenanceId', this.mouldBoms[index].MaintenanceId)
          this.$set(item, 'ProductionType', this.mouldBoms[index].ProductionType)
          this.$set(item, 'ProductionDpId', this.mouldBoms[index].ProductionDpId)
          this.$set(item, 'DocDate', this.mouldBoms[index].DocDate)
          this.$set(item, 'EndTime', this.mouldBoms[index].EndTime)
          this.$set(item, 'Remark', this.mouldBoms[index].Remark)
          this.$set(item, 'TeProductDetailId', this.mouldBoms[index].TeProductDetailId)
          this.$set(item, 'TebomId', this.mouldBoms[index].TebomId)
          this.$set(item, 'TespecialBomId', this.mouldBoms[index].TespecialBomId)
          this.$set(item, 'ProgrammeId', this.mouldBoms[index].ProgrammeId)
          item.OrderProductNo = this.OrderProductNo
        } else {
          this.$set(item, 'T', 0)
          this.$set(item, 'WorkDocId', 0)
          this.$set(item, 'WorkDocProductId', 0)
          this.$set(item, 'WorkDocNo', '')
          this.$set(item, 'Inventory', 0)
          this.$set(item, 'SchedulingType', null)
          this.$set(item, 'DpId', null)
          this.$set(item, 'MaintenanceId', null)
          this.$set(item, 'ProductionType', item.MouldNature)
          this.$set(item, 'ProductionDpId', item.MouldDefaultSupplier)
          this.$set(item, 'DocDate', this.$commonJs.getToday())
          this.$set(item, 'EndTime', '')
          this.$set(item, 'Remark', '')
          this.$set(item, 'TeProductDetailId', 0)
          this.$set(item, 'TebomId', 0)
          this.$set(item, 'TespecialBomId', 0)
          this.$set(item, 'ProgrammeId', 0)
        }
      })

      // this.mouldData.forEach(itme )
      this.mouldBoms = mouldData
      let ProcessModelsNames = this.ProcessModels.map(item => {
        return item.MouldName
      })
      let DetailModelsNames = this.DetailModels.map(item => {
        return item.MouldName
      })
      let arr = []
      let darr = []

      this.mouldBoms.forEach((item, i) => {
        let index = ProcessModelsNames.indexOf(item.MouldName)
        let dindex = DetailModelsNames.indexOf(item.MouldName)

        if (index !== -1) {
          arr.push(this.ProcessModels[index])
        } else if (index === -1) {
          let o = {
            MouldNo: item.MouldNo,
            MouldName: item.MouldName,
            ProgrammeName: '',
            ProgrammeId: 0,
            Processes: []
          }
          arr.push(o)
        }

        if (dindex !== -1) {
          darr.push(this.DetailModels[index])
        } else if (index === -1) {
          darr.push({
            Pname: item.Pname,
            DetailModels: []
          })
        }
      })

      this.ProcessModels = arr
      this.mouldBoms.forEach((item, i) => {
        let qua = item.qua
        darr[i].DetailModels.forEach(v => {
          v.qua = qua / v.rateQua
        })
      })
      this.DetailModels = darr
    },
    /** 批量操作 */
    handleSelectionChange(val) {
      this.selList = val
    },
    /** 批量-单据日期 */
    onDocDate() {
      this.mouldBoms = this.mouldBoms.map(obj1 => {
        let duplicateObj = this.selList.find(obj2 => obj2.MakeEmpId === obj1.MakeEmpId && obj2.MouldId === obj1.MouldId)
        if (duplicateObj) {
          obj1.DocDate = this.batchDocDate
        }
        return obj1
      })
      this.batchDocDate = ''
    },
    /** 批量-单据日期 */
    onDocEndTime() {
      this.mouldBoms = this.mouldBoms.map(obj1 => {
        let duplicateObj = this.selList.find(obj2 => obj2.MakeEmpId === obj1.MakeEmpId && obj2.MouldId === obj1.MouldId)
        if (duplicateObj) {
          obj1.EndTime = this.batchEndTime
        }
        return obj1
      })
      this.batchShowEndTime = this.batchEndTime
      this.batchEndTime = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 6px 0;
}

.flex1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 6px 0;
}
.flex2 {
  display: flex;
}
.mr8 {
  margin-right: 8px;
}
</style>
